export { ComponentClass, Component, PureComponent, ReactNode } from 'react';
import * as React from 'react';
export { React };
export { default as PropTypes } from 'prop-types';
// quite many components need to know who current user is, 
// and session should remain unchanged during application lifetime, 
// so we can save some lines by including it to every connect'ed component without any additional unnecessary updates
// and it should be faster than dedicated higher-level component, since there won't be additional new wrapper class per every component which needs session
import { connect as originalConnect } from 'react-redux';
export const connect: any = (mapStateToProps: any, ...rest: any[]): any =>
    (originalConnect as any)(
        !mapStateToProps || mapStateToProps.length === 1 ?
            function (this: any, state: any): any {
                return {
                    session: state.app.session,
                    ...(mapStateToProps ? mapStateToProps.call(this, state) : null)
                };
            } :
            function (this: any, state: any, ownProps: any): any {
                return {
                    session: state.app.session,
                    ...mapStateToProps.call(this, state, ownProps)
                };
            },
        ...rest);
import { DispatchProp as OriginalDispatchProp } from 'react-redux';
import { entities } from 'typed/api';
export interface DispatchProp<T> extends OriginalDispatchProp<T> { session: entities.Session; }
export { default as APIPropTypes } from 'api/propTypes';
export { default as defaults } from 'api/defaults';
import * as actions from 'actions';
export { actions };
export interface Location {
    pathname: string,
    query: { [key: string]: string };
}